module.exports = __webpack_public_path__ + "officialStatic/img/detail-four-bg.804603e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-four-bg.png
// module id = Speh
// module chunks = 0